import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import AdminEvents from "./AdminEvents";

function Admin() {
  const handleLogout = async () => {
    await signOut(auth);
    window.location.href = "/login";
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h1>Admin Panel</h1>
      <button onClick={handleLogout}>Logout</button>

      <AdminEvents />
    </div>
  );
}

export default Admin;
